import Service from './service'
export var SipMessageType;
(function (SipMessageType) {
  SipMessageType["SIP_STATUS_CHANGE"] = "SIP_STATUS_CHANGE"
  SipMessageType["SIP_TONE_EVENT"] = "SIP_TONE_EVENT"
})(SipMessageType || (SipMessageType = {}))
export var ApiSipMessageType;
(function (ApiSipMessageType) {
  ApiSipMessageType["SIP_DTMF_RESPONSE"] = "sip.dtmf.response"
  ApiSipMessageType["SIP_SIP_STATUS"] = "sip.sip.status"
  ApiSipMessageType["SIP_CONTROL"] = "sip.control"
  ApiSipMessageType["SIP_EVENTS"] = "sip.events"
})(ApiSipMessageType || (ApiSipMessageType = {}))
export var SipStatus;
(function (SipStatus) {
  /** Ожидание команды на звонок */
  SipStatus[SipStatus["IDLE"] = 0] = "IDLE"
  /** Начало звонка */
  SipStatus[SipStatus["START"] = 1] = "START"
  /** Подключение */
  SipStatus[SipStatus["CONNECTING"] = 2] = "CONNECTING"
  /** Подключение прошло успешно */
  SipStatus[SipStatus["CONNECTED"] = 3] = "CONNECTED"
  /** Произошла ошибка */
  SipStatus[SipStatus["FAILED"] = 4] = "FAILED"
  /** Звонок завершен */
  SipStatus[SipStatus["DISCONNECTED"] = 5] = "DISCONNECTED"
  /** Входящий вызов */
  SipStatus[SipStatus["INCOMING"] = 6] = "INCOMING"
})(SipStatus || (SipStatus = {}))

/**
 * Сервис для работы с SIP-телефонией
 * @version 0.0.1
 * @since 2.0.0
 */
export default class SipService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiSipMessageType.SIP_DTMF_RESPONSE:
          this.broadcast(SipMessageType.SIP_TONE_EVENT, message.value)
          break
        case ApiSipMessageType.SIP_SIP_STATUS:
          delete message.id
          delete message.type
          this.broadcast(SipMessageType.SIP_STATUS_CHANGE, message)
          break
      }
    }
    this.messageChannel.subscribe(ApiSipMessageType.SIP_DTMF_RESPONSE, messageHandler)
    this.messageChannel.subscribe(ApiSipMessageType.SIP_SIP_STATUS, messageHandler)
    this.messageChannel.subscribe(ApiSipMessageType.SIP_EVENTS, messageHandler)
  }
  /**
     * Повесить трубку
     * @since 2.0.0
     * @memberof SipService
     *
     * @example <caption>Повесить трубку</caption>
     * robot.sipService.callStop()
     */
  callStop() {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      call_stop: '',
    })
  }
  /**
     * Позвонить для разговора через микрофон
     * @since 2.0.0
     * @param {string} num - номер для звонка
     * @memberof SipService
     *
     * @example <caption>Позвонить для разговора через микрофон</caption>
     * robot.sipService.callStart(num)
     */
  callStart(num) {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      phone_number: num,
      call_start: null,
    })
  }
  /**
     * Позвонить и воспроизвести файл
     * @since 2.0.0
     * @param {string} num - номер для звонка
     * @param {string} filePath - путь к файлу
     * @memberof SipService
     *
     * @example <caption>Отправить сообщение в тональном режиме</caption>
     * robot.sipService.callStartWithFile(num, filePath)
     */
  callStartWithFile(num, filePath) {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      phone_number: num,
      file_path: filePath,
      call_with_file_start: null,
    })
  }
  /**
     * Позвонить и произнести текст
     * @since 2.0.0
     * @param {string} num - номер для звонка
     * @param {string} text - текст для произнесения
     * @memberof SipService
     *
     * @example <caption>Позвонить и произнести текст</caption>
     * robot.sipService.callStartWithText(num, text)
     */
  callStartWithText(num, text) {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      phone_number: num,
      text,
      call_with_text_start: null,
    })
  }
  /**
     * Воспроизвести файл в уже начатом звонке
     * @since 2.0.0
     * @param {string} filePath - путь к файлу
     * @memberof SipService
     *
     * @example <caption>Воспроизвести файл в уже начатом звонке</caption>
     * robot.sipService.playFile(filePath)
     */
  playFile(filePath) {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      play_file: '',
      file_path: filePath,
    })
  }
  /**
     * Проговорить текст в уже начатом звонке
     * @since 2.0.0
     * @param {string} text - текст для произнесения
     * @memberof SipService
     *
     * @example <caption>Проговорить текст в уже начатом звонке</caption>
     * robot.sipService.playText(text)
     */
  playText(text) {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      play_text: '',
      text,
    })
  }
  /**
     * Отправить сообщение в тональном режиме/DTMF
     * (например для ввода добавочного номера)
     * @since 2.0.0
     * @param {string} additional - сообщение в тональном режиме/DTMF
     * @memberof SipService
     *
     * @example <caption>Отправить сообщение в тональном режиме</caption>
     * robot.sipService.sendDtmf(additional)
     */
  sendDtmf(additional) {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      send_dtmf: '',
      tone: additional,
    })
  }
  /**
     * Изменился статус звонка
     * @since 2.0.0
     * @param {(status: SipStatus) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof SipService
     *
     * @example <caption>Изменился статус звонка</caption>
     * robot.sipService.onStatusChange((status) => {
     *   ...
     * })
     */
  onStatusChange(callback) {
    return this.subscribe(SipMessageType.SIP_STATUS_CHANGE, callback)
  }
  /**
     * Получено сообщение из режима тонального набора (DTMF)
     * @since 2.0.0
     * @param {(tone: string) => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof SipService
     *
     * @example <caption>Получено сообщение из режима тонального набора</caption>
     * robot.sipService.onToneEvent((tone) => {
     *   ...
     * })
     */
  onToneEvent(callback) {
    return this.subscribe(SipMessageType.SIP_TONE_EVENT, callback)
  }
  /**
     * Принять входящий вызов
     * @since 2.0.0
     * @memberof SipService
     *
     * @example <caption>Принять входящий вызов</caption>
     * robot.sipService.acceptIncomigCall()
     */
  acceptIncomigCall() {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      accept_call: '',
    })
  }
  /**
     * Принять входящий вызов без вывода звука в динамики и без микрофона
     * @since 2.0.0
     * @memberof SipService
     *
     * @example <caption>Принять входящий вызов без вывода звука в динамики и без микрофона</caption>
     * robot.sipService.quietIncomigCall()
     */
  quietIncomigCall() {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      accept_quiet: '',
    })
  }
  /**
     * Отменить входящий вызов
     * @since 2.0.0
     * @memberof SipService
     *
     * @example <caption>Отменить входящий вызов</caption>
     * robot.sipService.rejectIncomigCall()
     */
  rejectIncomigCall() {
    this.messageChannel.send({
      type: ApiSipMessageType.SIP_CONTROL,
      reject: '',
    })
  }
}
